import React from 'react';
import PropTypes from 'prop-types';
import styles from './PauseSlide.css';

function PauseSlide({ imageSrc, titlePrefix, titleAccent, isTitleInline = false, description }) {
    return (
        <div className={styles.form}>
            <div className={styles.imageWrapper}>
                <img src={imageSrc} alt='' className={styles.image} />
            </div>
            <h2 className={styles.heading}>
                {titlePrefix}
                {isTitleInline ? ' ' : <br />}
                <span className={styles.highlight}>{titleAccent}</span>
            </h2>
            <p className={styles.description}>{description}</p>
        </div>
    );
}

PauseSlide.propTypes = {
    imageSrc: PropTypes.string.isRequired,
    titlePrefix: PropTypes.node.isRequired,
    titleAccent: PropTypes.node.isRequired,
    isTitleInline: PropTypes.bool,
    description: PropTypes.node.isRequired
};

export {
    PauseSlide
};
